import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("filter", {
        id: "i2108518267__a",
        "color-interpolation-filters": "auto"
      }, [
        _createElementVNode("feColorMatrix", {
          in: "SourceGraphic",
          values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
        })
      ])
    ], -1),
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      filter: "url(#i2108518267__a)",
      transform: "translate(-575 -814)"
    }, [
      _createElementVNode("path", {
        fill: "#000C17",
        "fill-rule": "nonzero",
        d: "M613.86 820.66c-.63 0-1.14.52-1.14 1.15 0 .64.51 1.15 1.14 1.15.63 0 1.14-.51 1.14-1.15 0-.63-.51-1.15-1.14-1.15Zm-3.75-.88a1.6 1.6 0 0 0-1.64-1.57c-.9 0-1.64.7-1.64 1.57 0 .87.73 1.57 1.64 1.57.9 0 1.64-.7 1.64-1.57Zm.01-3.06h1.81v6.11h-1.8v-.39a3.21 3.21 0 0 1-5-2.66 3.21 3.21 0 0 1 5-2.67v-.39Zm-14.52.8v-.8h-1.86v6.11h1.87v-2.85c0-.96 1.03-1.48 1.75-1.48h.02v-1.78c-.74 0-1.41.32-1.78.8Zm-4.63 2.26a1.6 1.6 0 0 0-1.64-1.57c-.9 0-1.64.7-1.64 1.57 0 .87.73 1.57 1.64 1.57.9 0 1.64-.7 1.64-1.57Zm.01-3.06h1.81v6.11H591v-.39a3.21 3.21 0 0 1-5-2.66 3.21 3.21 0 0 1 5-2.67v-.39Zm10.92-.16c-.72 0-1.41.23-1.87.85v-.69h-1.8v6.11h1.82v-3.2c0-.94.62-1.4 1.37-1.4.8 0 1.25.49 1.25 1.38v3.22h1.81v-3.88c0-1.42-1.12-2.4-2.58-2.4Zm-18.56 6.27h1.9V814h-1.9v8.83Zm-8.34 0h2.01V814H575v8.83Zm7.03-8.83c0 1.91-.74 3.7-2.05 5.01l2.78 3.82h-2.49l-3.02-4.15.78-.59a5.09 5.09 0 0 0 2.04-4.09h1.96Z"
      })
    ], -1)
  ])))
}
export default { render: render }